"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var mobx_react_1 = require("mobx-react");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var path_1 = require("../../definition/path");
var storeProvider_1 = require("../../storeProvider");
var OfferProductSection_1 = __importDefault(require("./components/OfferProductSection"));
var Offers_module_scss_1 = __importDefault(require("./Offers.module.scss"));
var Offers = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var offerStore = (0, storeProvider_1.useStore)().offerStore;
    (0, react_1.useEffect)(function () {
        void offerStore.initializeSessionAndLoadOffers();
    }, [offerStore]);
    var handleBuyNow = function (product) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (((_a = product.remainingSeats) !== null && _a !== void 0 ? _a : 0) <= 0) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, offerStore.purchaseSelectedOffers([product])];
                case 1:
                    response = _b.sent();
                    if (response.status === "success") {
                        navigate("".concat(path_1.Page.TicketPage, "?session-id=").concat(encodeURIComponent(offerStore.sessionId)), { replace: true });
                        return [2 /*return*/];
                    }
                    if (response.status === "pending") {
                        if (response.paymentUrl) {
                            window.open(response.paymentUrl, "_blank", "noopener,noreferrer");
                        }
                        navigate("".concat(path_1.Page.WaitingPurchasePage, "?order-id=").concat(encodeURIComponent(response.orderId || ""), "&session-id=").concat(encodeURIComponent(offerStore.sessionId)), { replace: true });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("main", { className: Offers_module_scss_1.default.catalogPage, children: [(0, jsx_runtime_1.jsxs)("header", { className: Offers_module_scss_1.default.catalogHeader, children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: Offers_module_scss_1.default.backButton, onClick: function () { return navigate(path_1.Page.OfferPage); }, children: t("OFFER_ALL_BACK") }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { className: Offers_module_scss_1.default.eyebrow, children: t("OFFER_ALL_EYEBROW") }), (0, jsx_runtime_1.jsx)("h1", { children: t("OFFER_ALL_TITLE") }), (0, jsx_runtime_1.jsx)("p", { className: Offers_module_scss_1.default.subtitle, children: t("OFFER_ALL_DESC") })] })] }), (0, jsx_runtime_1.jsx)(OfferProductSection_1.default, { products: offerStore.offers.filter(function (offer) { var _a; return (_a = offer.shelf) === null || _a === void 0 ? void 0 : _a.includes("all"); }), buyNowText: t("OFFER_BUY_NOW"), cartText: t("OFFER_CART"), onBuyNowClick: handleBuyNow, onCartClick: offerStore.toggleCartSelection, isSelected: function (offerId) { return offerStore.isSelected(offerId); }, isLoading: offerStore.isLoadingOffers, showAll: true })] }));
};
exports.default = (0, mobx_react_1.observer)(Offers);
